<div>
	<app-create-company-side-form
		[label]="label"
		[minify]="false"
		(onSubmit)="onSubmit($event)"
		(onCancel)="onCancel()"
		[name]="name"
		[company]="company"
	>
	</app-create-company-side-form>
</div>
